import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import * as Sentry from '@sentry/react'
import { DarkModeProvider } from './context/DarkModeContext'
import { AuthProvider } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Footer from './components/Footer'
import Login from './pages/Login'
import Home from './pages/Home'
import Moderator from './pages/Moderator'
import Player from './pages/Player'
import Impressum from './pages/Impressum'
import Datenschutz from './pages/Datenschutz'
import Spielanleitung from './pages/Spielanleitung'
import FAQ from './pages/FAQ'

function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 max-w-md w-full">
            <h1 className="text-2xl font-bold text-red-600 dark:text-red-400 mb-4">
              Oops! Something went wrong
            </h1>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              We're sorry, but something unexpected happened. The error has been reported to our team.
            </p>
            <details className="mb-4">
              <summary className="cursor-pointer text-sm text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200">
                Technical details
              </summary>
              <pre className="mt-2 text-xs bg-gray-100 dark:bg-gray-900 p-2 rounded overflow-auto">
                {error.toString()}
              </pre>
            </details>
            <button
              onClick={resetError}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded transition-colors"
            >
              Try again
            </button>
          </div>
        </div>
      )}
      showDialog={false}
    >
      <HelmetProvider>
        <DarkModeProvider>
          <AuthProvider>
            <Router>
              <div className="min-h-screen flex flex-col">
                <div className="flex-1">
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<Home />} />
                    <Route
                      path="/moderator"
                      element={
                        <ProtectedRoute>
                          <Moderator />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="/player" element={<Player />} />
                    <Route path="/impressum" element={<Impressum />} />
                    <Route path="/datenschutz" element={<Datenschutz />} />
                    <Route path="/spielanleitung" element={<Spielanleitung />} />
                    <Route path="/faq" element={<FAQ />} />
                  </Routes>
                </div>
                <Footer />
              </div>
            </Router>
          </AuthProvider>
        </DarkModeProvider>
      </HelmetProvider>
    </Sentry.ErrorBoundary>
  )
}

export default App
